import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import type { FootageView } from '../footage/footageView';
import { panelMessages } from '../messages/panelMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the editor; each part uses its own slice of it */
import styles from '../MusicVideoEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

const SOURCE_MESSAGES = {
  bank: panelMessages.sourceBank,
  upload: panelMessages.sourceUpload,
  ai: panelMessages.sourceAi,
  songVideo: panelMessages.sourceSongVideo,
} as const;

/** Where a clip comes from (design b1 "Bank", c3 "Your clip · 1080 × 1920", h3 "AI clip · yours · made 9 Oct"). */
const ClipSourceLineComponent: React.FC<{ view: FootageView | null }> = ({ view }) => {
  const intl = useIntl();
  if (view === null) {
    return null;
  }
  if (view.origin === 'ai' && view.createdAt !== null) {
    return (
      <small className={styles.hint}>
        {intl.formatMessage(panelMessages.aiMadeOn, {
          date: intl.formatDate(view.createdAt, { day: 'numeric', month: 'short' }),
        })}
      </small>
    );
  }
  const source = intl.formatMessage(SOURCE_MESSAGES[view.origin]);
  return (
    <small className={styles.hint}>
      {view.width !== null && view.height !== null
        ? intl.formatMessage(panelMessages.sourceSize, { source, width: view.width, height: view.height })
        : source}
    </small>
  );
};

export const ClipSourceLine = TypedMemo(ClipSourceLineComponent);
